import { StoreState } from '../store-interfaces';

export const selectAdAudiences = (state: StoreState) =>
  state.adAudiences.entities || [];

export const selectAdAudience = (state: StoreState, id) =>
  state.adAudiences.entities.find(v => v.id === id);
